import React, { Fragment } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import {
    Card,
    Nav,
    NavLink,
    NavItem,
} from "reactstrap";

import { Elastic } from "react-burgers";

import cx from "classnames";
import Footer from '../../Layout/AppFooter';
import WhatsappSettings from "./Whatsapp";
import AccountSettings from "./Accounts";
import TemplateSettings from "./Templates";
import Integrations from "./Integrations";
import FieldCustomization from "./LegacySettings/FieldCustomization";
import Administration from "./Administration";
import Notifications from "./Notification"
import CloudTelephony from "./CloudTelephony";
import CustomForms from "./CustomForms";
import CRMTemplates from './CRMTemplates';
import RCSBusinessSettings from "./RCS/index";
import RCSTemplatesSettings from "./RCS/Templates";
import RCSCampaigns from "./RCS/RCSCampaigns";
import {
    getSessionValue, isAddonModuleEnabled, getAccessedFormsFromProfile,
    getAppType,
    getGeneralSettings
} from "../../Common/Appcommon";

class SettingsContent extends React.Component {

    componentMapper = {};
    appType = getAppType();

    constructor(props) {
        super(props);

        this.state = {
            active: false,
            currentComponent: AccountSettings,
            currentSettings: "account",
            selectedComponent: props.selectedComponent,
            selectedTab: props.selectedTab,
            formname: props.formname,
            formid: props.formid,
            action: props.action,
            crmTemplates: this.getProfileAccessedFormTabs(),
            isRcsEnabled: getSessionValue('NEED_RCS_SETUP') === 'true' || getSessionValue('NEED_RCS_SETUP') === '1'
        };

        this.componentMapper = {
            whatsapp: WhatsappSettings,
            account: AccountSettings,
            templates: TemplateSettings,
            crmTemplates: CRMTemplates,
            integrations: Integrations,
            customization: FieldCustomization,
            administration: Administration,
            notification: Notifications,
            cloudtelephony: CloudTelephony,
            customforms: CustomForms,
            rcs_business: RCSBusinessSettings,
            rcs_templates: RCSTemplatesSettings,
            rcs_campaigns: RCSCampaigns
        }

    }

    componentDidMount = async () => {
        //await getAppFeatureSet();
        const needRcsSetup = await getGeneralSettings("NEED_RCS_SETUP");
        this.setState({ isRcsEnabled: needRcsSetup === 'true' || needRcsSetup === '1' || needRcsSetup === true });
        
        if (this.state.selectedComponent !== '') {
            this.onSettingsMenuChange('', this.state.selectedComponent);
        }
    }

    onSettingsMenuChange = async (e, menuName) => {
        let component = this.componentMapper[menuName];
        this.setState({
            currentComponent: component,
            currentSettings: menuName
        });
    }

    getProfileAccessedFormTabs = async () => {
        let tabList = "table_23";;
        let responce = await getAccessedFormsFromProfile(tabList);

        if (responce.issuccess) {
            let data = responce.data;
            if (tabList === data[0]) {
                return true;
            }
        }
        return false;
    }
    render() {

        let {
            active,
            selectedTab,
            currentSettings,
            formid,
            formname,
            action,
            crmTemplates
        } = this.state;
        let currentmenu = getSessionValue("menus");
        let isFFTEnabled = isAddonModuleEnabled("cloud_telephony");
        const whatsappSettingsMenu = [];
        let wshide = true;
        let CurrentComponent = this.state.currentComponent;
        let isAutomation = currentmenu.indexOf("Automation");
        let isCampaign = currentmenu.indexOf("Campaigns");
        let isAnalytics = currentmenu.indexOf("Analytics");
        const crmSettingsMenu = [
            { name: 'account', label: 'Account', icon: 'pe-7s-home' },
            { name: 'administration', label: 'Administration', icon: 'pe-7s-config' },
            { name: 'notification', label: 'Notifications', icon: 'pe-7s-bell' },
            { name: 'integrations', label: 'Integrations', icon: 'pe-7s-shuffle' },
            { name: 'customforms', label: 'Custom Forms', icon: 'pe-7s-bookmarks' },
        ];
        if (crmTemplates) {
            crmSettingsMenu.splice(2, 0, { name: 'crmTemplates', label: 'Templates', icon: 'pe-7s-file' });
        }
        if (isFFTEnabled) {
            crmSettingsMenu.push({ name: 'cloudtelephony', label: 'Cloud Telephony', icon: 'pe-7s-cloud' });
        }
        if (isAutomation > 0 && isCampaign > 0 && isAnalytics > 0) {
            wshide = false;
            if (this.appType === '1') {
                whatsappSettingsMenu.push({ name: 'account', label: 'Account', icon: 'pe-7s-home' });
            }
            whatsappSettingsMenu.push({ name: 'whatsapp', label: 'WABA Business', icon: 'pe-7s-chat' });
            whatsappSettingsMenu.push({ name: 'templates', label: 'Templates', icon: 'pe-7s-photo-gallery' });
            if (this.appType === '1') {
                whatsappSettingsMenu.push({ name: 'administration', label: 'Administration', icon: 'pe-7s-config' });
                whatsappSettingsMenu.push({ name: 'integrations', label: 'Integrations', icon: 'pe-7s-shuffle' });
            }
        }

        const rcsSettingsMenu = [
            { name: 'rcs_business', label: 'RCS Business', icon: 'pe-7s-chat' },
            { name: 'rcs_templates', label: 'Templates', icon: 'pe-7s-photo-gallery' },
            //{ name: 'rcs_campaigns', label: 'Campaigns', icon: 'pe-7s-speaker' },
        ]

        let that = this;
        return (
            <Fragment>
                <TransitionGroup>
                    <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                        timeout={1500} enter={false} exit={false}>
                        <div>
                            <div className={cx("app-inner-layout TabsAnimation", {
                                "open-mobile-menu": active,
                            })}>
                                <div className="app-inner-layout__wrapper">
                                    <Card className="app-inner-layout__content">
                                        <CurrentComponent
                                            defaultSelectedTab={selectedTab}
                                            formid={formid}
                                            formname={formname}
                                            action={action}
                                        />
                                    </Card>
                                    <Card className="app-inner-layout__sidebar">
                                        {that.appType === '2' && <Nav vertical>
                                            <NavItem className="nav-item-header nav-header-font">CRM Settings</NavItem>
                                            {crmSettingsMenu.map((menu) => {
                                                return (
                                                    <NavItem>
                                                        <NavLink
                                                            className={` ${currentSettings == menu.name ? 'active' : ''}`}
                                                            href="#"
                                                            onClick={(e) => { this.onSettingsMenuChange(e, menu.name) }}>
                                                            <i className={`nav-link-icon ${menu.icon} `}> </i>
                                                            <span>{menu.label}</span>
                                                        </NavLink>
                                                    </NavItem>
                                                )
                                            })
                                            }
                                        </Nav>}

                                        <Nav vertical>
                                            <NavItem className={`nav-item-header nav-header-font ${wshide ? 'hide' : ''}`}>{that.appType === '1' ? 'Settings' : 'WhatsApp Settings'}</NavItem>
                                            {whatsappSettingsMenu.map((menu) => {
                                                return (
                                                    <NavItem>
                                                        <NavLink
                                                            className={` ${currentSettings == menu.name ? 'active' : ''}`}
                                                            href="#"
                                                            onClick={(e) => { this.onSettingsMenuChange(e, menu.name) }}>
                                                            <i className={`nav-link-icon ${menu.icon} `}> </i>
                                                            <span>{menu.label}</span>
                                                        </NavLink>
                                                    </NavItem>
                                                )
                                            })
                                            }
                                        </Nav>
                                        {this.state.isRcsEnabled && (
                                            <Nav vertical>
                                                <NavItem className={`nav-item-header nav-header-font`}>RCS Settings</NavItem>
                                                {rcsSettingsMenu.map((menu) => {
                                                    return (
                                                        <NavItem>
                                                            <NavLink
                                                                className={` ${currentSettings == menu.name ? 'active' : ''}`}
                                                                href="#"
                                                                onClick={(e) => { this.onSettingsMenuChange(e, menu.name) }}>
                                                                <i className={`nav-link-icon ${menu.icon} `}> </i>
                                                                <span>{menu.label}</span>
                                                            </NavLink>
                                                        </NavItem>
                                                    )
                                                })
                                                }
                                            </Nav>
                                        )}
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </TransitionGroup>
                <Footer />
            </Fragment>
        );
    }
}

export default SettingsContent;
